<template>
  <div class="container">
    <headTop />
    <div class="content">
      <!-- 面包屑 -->
      <div class="nav">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{ $t('navbar.home') }}</el-breadcrumb-item>
          <el-breadcrumb-item> {{ $t('navbar.activity') }}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search">
          <p>{{ $t('navbar.activity') }}</p>
          <div class="serach_content">
            <el-input :placeholder="$t('activity.placeholder')" v-model="search"> </el-input>
            <el-button type="primary" icon="el-icon-search" class="search_button" @click="searchActive"></el-button>
          </div>
        </div>
      </div>

      <!-- 标签页 -->
      <div class="tab">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="$t('activity.all')" :name="$t('activity.all')">
            <div class="live-box">
              <div class="live-box" v-if="activeData.length > 0">
                <div class="item" v-for="(item, index) in activeData" :key="index" @click="activeDetail(item.id)">
                  <div class="vedio">
                    <img
                      :src="item.collectStatus == 0 ? require('../../static/collent.png') : require('../../static/collent_yello.png')"
                      @click.stop="toggle(item)"
                      class="shoucang"
                      alt=""
                    />
                    <img class="vedio_picture" :src="item.column15" v-if="item.column15.substr(0,4) == 'http'"/>
                    <img class="vedio_picture" :src="baseUrl + item.column15" v-else />
                  </div>

                  <div class="title">
                    <p>{{ item.actTitle }}</p>

                    <p style="color: #666666; font-size: 16px;margin-top:15px">
                      <span><img src="../../static/ico_time.png" align="absmiddle" alt="" /> </span>{{ item.startTime }}
                    </p>

                    <p style="font-size: 16px;color: #666666">
                      <span> <img src="../../static/ico_address.png" align="absmiddle"/></span>
                      {{ $t('activity.place') }}
                      <span style="color: #666666;font-size: 16px">{{ item.hzBoothList[0] && item.hzBoothList[0].boothNum ? item.hzBoothList[0].boothNum: '' }}</span>
                    </p>
                  </div>

                  <!---------公司名称------------>
                  <div class="down">
                    <p>{{ item.hzExhibitor.companyNameC }}</p>
                  </div>
                </div>
              </div>

              <div class="boxImg" v-else>
                <img src="../../static/empty.png" alt="" />
                <div>{{ $t('activity.nodata') }}</div>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane :label="$t('activity.forum')" :name="$t('activity.forum')">
            <div class="live-box">
              <div class="live-box" v-if="activeData.length > 0">
                <div class="item" v-for="(item, index) in activeData" :key="index" @click="activeDetail(item.id)">
                  <div class="vedio">
                    <img
                      :src="item.collectStatus == 0 ? require('../../static/collent.png') : require('../../static/collent_yello.png')"
                      @click.stop="toggle(item)"
                      class="shoucang"
                      alt=""
                    />
                    <img class="vedio_picture" :src="item.column15" v-if="item.column15.substr(0,4) == 'http'"/>
                    <img class="vedio_picture" :src="baseUrl + item.column15" v-else />
                  </div>

                  <div class="title">
                    <p>{{ item.actTitle }}</p>

                    <p style="color: #666666; font-size: 16px;margin-top:15px">
                      <span><img src="../../static/ico_time.png" align="absmiddle" alt="" /> </span>{{ item.startTime }}
                    </p>

                    <p style="font-size: 16px; color: #666666">
                      <span> <img src="../../static/ico_address.png" align="absmiddle"/></span>
                      {{ $t('activity.place') }}
                      <span style="color: #666666">{{item.hzBoothList[0] && item.hzBoothList[0].boothNum ? item.hzBoothList[0].boothNum: '' }}</span>
                    </p>
                  </div>

                  <!---------公司名称------------>
                  <div class="down">
                    <p>{{ item.hzExhibitor.companyNameC }}</p>
                  </div>
                </div>
              </div>

              <div class="boxImg" v-else>
                <img src="../../static/empty.png" alt="" />
                <div>{{ $t('activity.nodata') }}</div>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane :label="$t('activity.technicalMeeting')" :name="$t('activity.technicalMeeting')">
            <div class="live-box">
              <div class="live-box" v-if="activeData.length > 0">
                <div class="item" v-for="(item, index) in activeData" :key="index" @click="activeDetail(item.id)">
                  <div class="vedio">
                    <img
                      :src="item.collectStatus == 0 ? require('../../static/collent.png') : require('../../static/collent_yello.png')"
                      @click.stop="toggle(item)"
                      class="shoucang"
                      alt=""
                    />
                    <img class="vedio_picture" :src="item.column15" v-if="item.column15.substr(0,4) == 'http'"/>
                    <img class="vedio_picture" :src="baseUrl + item.column15" v-else />
                  </div>

                  <div class="title">
                    <p>{{ item.actTitle }}</p>

                    <p style="color: #666666;font-size: 16px;margin-top:15px;">
                      <span><img src="../../static/ico_time.png" align="absmiddle" alt="" /> </span>{{ item.startTime }}
                    </p>

                    <p style="font-size: 16px; color: #666666">
                      <span> <img src="../../static/ico_address.png" align="absmiddle"/></span>
                      {{ $t('activity.place') }}
                      <span style="color: #666666">{{ item.hzBoothList[0] && item.hzBoothList[0].boothNum ? item.hzBoothList[0].boothNum: '' }}</span>
                    </p>
                  </div>

                  <!---------公司名称------------>
                  <div class="down">
                    <p>{{ item.hzExhibitor.companyNameC }}</p>
                  </div>
                </div>
              </div>

              <div class="boxImg" v-else>
                <img src="../../static/empty.png" alt="" />
                <div>{{ $t('activity.nodata') }}</div>
              </div>
            </div></el-tab-pane
          >

          <el-tab-pane :label="$t('activity.productLaunch')" :name="$t('activity.productLaunch')">
            <div class="live-box">
              <div class="live-box" v-if="activeData.length > 0">
                <div class="item" v-for="(item, index) in activeData" :key="index" @click="activeDetail(item.id)">
                  <div class="vedio">
                    <img
                      :src="item.collectStatus == 0 ? require('../../static/collent.png') : require('../../static/collent_yello.png')"
                      @click.stop="toggle(item)"
                      class="shoucang"
                      alt=""
                    />
                    <img class="vedio_picture" :src="item.column15" v-if="item.column15.substr(0,4) == 'http'"/>
                    <img class="vedio_picture" :src="baseUrl + item.column15" v-else />
                  </div>

                  <div class="title">
                    <p>{{ item.actTitle }}</p>

                    <p style="color: #666666;font-size: 16px;margin-top:15px;">
                      <span><img src="../../static/ico_time.png" align="absmiddle" alt="" /> </span>{{ item.startTime }}
                    </p>

                    <p style="font-size: 16px; color: #666666">
                      <span> <img src="../../static/ico_address.png" align="absmiddle"/></span>
                      {{ $t('activity.place') }}
                      <span style="color: #666666">{{ item.hzBoothList[0] && item.hzBoothList[0].boothNum ? item.hzBoothList[0].boothNum: '' }}</span>
                    </p>
                  </div>

                  <!---------公司名称------------>
                  <div class="down">
                    <p>{{ item.hzExhibitor.companyNameC }}</p>
                  </div>
                </div>
              </div>

              <div class="boxImg" v-else>
                <img src="../../static/empty.png" alt="" />
                <div>{{ $t('activity.nodata') }}</div>
              </div>
            </div></el-tab-pane
          >

          <el-tab-pane :label="$t('activity.standActivities')" :name="$t('activity.standActivities')">
            <div class="live-box">
              <div class="live-box" v-if="activeData.length > 0">
                <div class="item" v-for="(item, index) in activeData" :key="index" @click="activeDetail(item.id)">
                  <div class="vedio">
                    <img
                      :src="item.collectStatus == 0 ? require('../../static/collent.png') : require('../../static/collent_yello.png')"
                      @click.stop="toggle(item)"
                      class="shoucang"
                      alt=""
                    />
                    <img class="vedio_picture" :src="item.column15"  v-if="item.column15.substr(0,4) == 'http'"/>
                    <img class="vedio_picture" :src="baseUrl + item.column15"  v-else/>
                  </div>

                  <div class="title">
                    <p>{{ item.actTitle }}</p>

                    <p style="color: #666666; font-size: 16px;margin-top:15px">
                      <span><img src="../../static/ico_time.png" align="absmiddle" alt="" /> </span>{{ item.startTime }}
                    </p>

                    <p style="font-size: 16px; color:#666666">
                      <span> <img src="../../static/ico_address.png" align="absmiddle"/></span>
                      {{ $t('activity.place') }}
                      <span style="color: #666666">{{ item.hzBoothList[0] && item.hzBoothList[0].boothNum ? item.hzBoothList[0].boothNum: '' }}</span>
                    </p>
                  </div>

                  <!---------公司名称------------>
                  <div class="down">
                    <p>{{ item.hzExhibitor.companyNameC }}</p>
                  </div>
                </div>
              </div>

              <div class="boxImg" v-else>
                <img src="../../static/empty.png" alt="" />
                <div>{{ $t('activity.nodata') }}</div>
              </div>
            </div></el-tab-pane
          >

          <el-tab-pane :label="$t('activity.otherActivity')" :name="$t('activity.otherActivity')">
            <div class="live-box">
              <div class="live-box" v-if="activeData.length > 0">
                <div class="item" v-for="(item, index) in activeData" :key="index" @click="activeDetail(item.id)">
                  <div class="vedio">
                    <img
                      :src="item.collectStatus == 0 ? require('../../static/collent.png') : require('../../static/collent_yello.png')"
                      @click.stop="toggle(item)"
                      class="shoucang"
                      alt=""
                    />
                    <img class="vedio_picture" :src="item.column15" v-if="item.column15.substr(0,4) == 'http'"/>
                    <img class="vedio_picture" :src="baseUrl + item.column15" v-else />
                  </div>

                  <div class="title">
                    <p>{{ item.actTitle }}</p>

                    <p style="color: #666666; font-size: 16px;margin-top:15px">
                      <span><img src="../../static/ico_time.png" align="absmiddle" alt="" /> </span>{{ item.startTime }}
                    </p>

                    <p style="font-size: 16px; color: #666666">
                      <span> <img src="../../static/ico_address.png" align="absmiddle"/></span>
                      {{ $t('activity.place') }}
                      <span style="color: #666666">{{item.hzBoothList[0] && item.hzBoothList[0].boothNum ? item.hzBoothList[0].boothNum: '' }}</span>
                    </p>
                  </div>

                  <!---------公司名称------------>
                  <div class="down">
                    <p>{{ item.hzExhibitor.companyNameC }}</p>
                  </div>
                </div>
              </div>

              <div class="boxImg" v-else>
                <img src="../../static/empty.png" alt="" />
                <div>{{ $t('activity.nodata') }}</div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <!--分页 -->
        <div class="pagination">
          <span>{{ $t('common.pagination', { allNum: totalNum }) }}</span>
          <el-pagination
            v-if="pageshow"
            class="explore_right_pages"
            layout="prev, pager, next"
            :current-page="currentPage4"
            @current-change="handleCurrentChange"
            :page-size="12"
            :total="totalNum"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 尾部组件 -->
    <down-foot />
  </div>
</template>

<script>
import headTop from '../../common/head.vue';
import * as tools from '../../../utils/roulink';
import downFoot from '../../common/footBottom.vue';
import { forMat } from '../../../utils/common';

//导入活动接口
import { getActive, collectActive } from '../../../api/activePage';

export default {
  data() {
    return {
      activeName: this.$t('activity.all'),
      search: '', //输入框的内容
      currentPage4: 1, //分页当前页
      visible: true, //弹框可见
      collent_toggle: true,
      baseUrl: forMat(),
      totalNum: 1,
      activeData: [],
      pageNum: '1',
      pageshow: true
    };
  },

  components: {
    headTop,
    downFoot,
  },

  computed: {},
  created() {
    // this.getAct("1");
    const href = window.location.href;
    if (href.includes('tab')) {
      const arr = decodeURI(href).split('=');
      this.activeName = arr[1];
      if (this.activeName != this.$t('activity.all')) {
        // console.log('刚进来传参',this.activeName);
        this.getAct(this.pageNum, '', String(this.activeName));
      }
    } else {
      this.getAct('1');
      const lang = localStorage.getItem('lang');
      if (lang == 'en') {
        this.activeName = 'All Exhibits';
      }
    }
  },
  watch: {
    activeName(newVal, oldVal) {
      const lang = localStorage.getItem('lang');
      if (lang == 'en') {
        if (newVal !== oldVal) {
          switch (newVal) {
            case '论坛':
              this.activeName = this.$t('activity.forum');
              break;
            case '技术交流会':
              this.activeName = this.$t('activity.technicalMeeting');
              break;
            case '产品发布会':
              this.activeName = this.$t('activity.productLaunch');
              break;
            case '展台活动':
              this.activeName = this.$t('activity.standActivities');
              break;
            case '其他活动':
              this.activeName = this.$t('activity.otherActivity');
              break;
            default:
              this.activeName = this.$t('activity.all');
              break;
          }
        }
      }
    },
  },
  methods: {
    // 请求所有数据
    async getAct(pageNum, activeName, activeType) {
      const params = {
        pageNo: pageNum,
        pageSize: '12',
        keyword: activeName,
        activeType: activeType == '全部' ? '' : activeType
      };
      const { data } = await getActive(params);
      this.activeData = data.data.list;
      console.log('11111',this.activeData);
      this.totalNum = data.data.count;
    },
    //标签切换事件
    handleClick(tab, event) {
      console.log(tab.label);
      switch (tab.label) {
        case this.$t('activity.forum'):
          this.activeName = String('论坛');
          break;
        case this.$t('activity.technicalMeeting'):
          this.activeName = String('技术交流会');
          break;
        case this.$t('activity.productLaunch'):
          this.activeName = String('产品发布会');
          break;
        case this.$t('activity.standActivities'):
          this.activeName = String('展台活动');
          break;
        case this.$t('activity.otherActivity'):
          this.activeName = String('其他活动');
          break;
        default:
          this.activeName =String('全部');
          break;
      }
      this.getAct(this.pageNum, '', String(this.activeName));
    },

    //搜索活动
    searchActive() {
      this.currentPage4 = 1
      this.pageshow = false
      this.getAct(this.pageNum, this.search, '');
      this.$nextTick(()=>{
        this.pageshow = true
      })
      this.activeName = this.$t('activity.all');
    },

    //分页点击时间
    handleCurrentChange(val) {
      this.getAct(val,this.search);
      this.pageNum = val;
    },
    //点击进入活动详情
    activeDetail(item) {
      const id = item;
      this.$router.push({ path: '/active_detail', query: { id: id } });
    },
    //-----------------------------------

    //判断点击收藏状态
    async toggle(item) {
      let collObj = {};
      collObj.objId = String(item.id);
      collObj.type = 4;
      const state = Number(item.collectStatus); //判断当前的状态
      state == 0 ? (collObj.flag = true) : (collObj.flag = false);

      //符合条件说明是当前这个
      try {
        const { data } = await collectActive(collObj);
        if (state == 0) {
          if (data.code == 200) {
            this.collectFlag = true;
            this.$message({
              showClose: true,
              message: this.$t('common.successCollect'),
              type: 'success',
            });
            this.getAct(this.pageNum);
            return false;
          } else {
            // this.$message({
            //   showClose: true,
            //   message: data.msg,
            //   type: "warning",
            // });
            tools.login(3);
          }
        } else {
          if (data.code == 200) {
            this.collectFlag = false;
            this.$message({
              showClose: true,
              message: this.$t('common.cancelCollect'),
              type: 'success',
            });
            this.getAct(this.pageNum);
            return false;
          } else {
            // this.$message({
            //   showClose: true,
            //   message: data.msg,
            //   type: "warning",
            // });
            tools.login(3);
          }
        }
      } catch (err) {
        console.log(err);
      }
    },

    //关闭弹窗
    close() {
      this.visible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.el-tab-pane {
  height: inherit !important;
}
.container {
  width: 100%;
  // height: 2010px;
  margin-top: 120px;
  .content {
    width: 1370px; //加阴影面积的宽度 或者覆盖.el-tabs__content的overflow：hidden属性
    margin: 0 auto;
    margin-bottom: 33px;
    .search {
      display: flex;
      // border: 1px solid red;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 41px;
      margin-top: 28px;
      .serach_content {
        display: flex;
      }
      .search_button {
        width: 70px;
        height: 38px;
        background: #006fb8;
      }
    }
    .nav {
      margin-top: 24px;
      padding: 0 50px;
    }
    .nav p {
      width: 120px;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      display: block;
    }
    .tab {
      ::v-deep.el-tabs__header {
        padding: 0 50px; //加阴影面积的宽度
      }
      .live-box {
        display: flex;
        //width: 1270px;
        width: 100%;
        flex-wrap: wrap;
        margin-bottom: 30px;
        padding: 0 25px; //加阴影面积的宽度

        .item {
          border: 1px solid red;
          width: 403px;
          height: 459px;
          margin-bottom: 26px;
          border: 1px solid #e0e0e0;
          &:hover {
            box-shadow: 0px 0px 50px 0px #e8ecf0;
            position: relative;
          }

          .vedio {
            width: 403px;
            height: 269px;
            margin-bottom: 20px;
            //border: 1px yellow solid;
            position: relative;

            .shoucang {
              position: absolute;
              z-index: 9;
              right: 10px;
              top: 10px;
            }
            .vedio_picture {
              width: 100%;
              height: 100%;
            }
          }
          .title {
            box-sizing: border-box;
            height: 117px;
            padding: 0px 35px 22px 24px;
            p:first-child {
              font-size: 18px;
            }
            p {
              margin-top: 10px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }
          }
          .down {
            border-top: 1px #e0e0e0 solid;
            height: 60px;
            p {
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 51px;
              margin-left: 30px;

              color: #999999;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }
          }
        }
        .item:not(:nth-child(3n)) {
          margin-right: calc(8% / 4);
        }
      }
    }
    .pagination {
      // border: 1px solid red;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 30px;
      span {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-top: 6px;
        color: #666666;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.el-input >>> .el-input__inner {
  width: 550px;
  height: 40px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.el-breadcrumb >>> .el-breadcrumb {
  margin: 24px 0 28px;
}

.tab >>> .el-tab-pane {
  height: 1500px;

  /* border: 1px solid red; */
}
.tab >>> .el-tabs__nav-wrap::after {
  background: white;
  position: static !important;
  height: 0;
}
::v-deep .explore_right_pages {
  display: flex;
  align-items: center;
  justify-content: center;

  .el-pagination button:hover {
    color: #978d8d;
  }
  .el-pagination button {
    color: #999999;
  }

  .el-pager li {
    background-color: unset;
  }
  .el-pager li:hover {
    color: #999999;
  }
  .btn-prev {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
    margin-left: 10px;
  }
  .btn-next {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
  }
  .el-pager .number {
    width: 32px;
    height: 32px;
    line-height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #cccccc;
    margin-right: 5px;
    margin-right: 5px;
    color: #999999;
  }
  .el-pager .number:hover {
    color: #006fb8;
  }
  .el-pager li.active {
    border: none;
    cursor: pointer;
    background: #006fb8;
    color: #fff;
  }
  .el-pager li.active:hover {
    color: #fff;
    background: #006fb8;
  }
  .el-pager li.btn-quicknext {
    line-height: 28px;
    color: #999;
  }
}
</style>

<style scoped>
.boxImg {
  margin: 0 auto;

  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}

.boxImg img {
  width: 380px;
  height: 300px;
}
</style>
<style>
.el-tabs__item {
  font-size: 16px;
}
</style>
